import type { ReactNode } from "react";

/**
 * Splice nodes into a translated string at its `{token}` placeholders, e.g.
 * "I agree to the {terms} and the {privacy}." → text, node, text, node, text.
 * An unknown token is dropped rather than printed raw.
 */
export function withInlineNodes(template: string, nodes: Record<string, ReactNode>): ReactNode {
  const parts = template.split(/\{(\w+)\}/);
  if (parts.length < 2) return template;
  return (
    <>
      {parts.map((part, index) => (index % 2 === 1 ? <span key={index}>{nodes[part] ?? null}</span> : part))}
    </>
  );
}
